(() => {
  if (window.__hiknightMobileMenuLoaded) return;
  window.__hiknightMobileMenuLoaded = true;
  const mobileMQ = window.matchMedia('(max-width: 1023px)');
  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const SIMPLE_SUBMENU_LABELS = ['accessories', 'accessories & parts', 'support'];

  function isSimpleSubmenuLabel(value) {
    const label = normalize(value);
    return SIMPLE_SUBMENU_LABELS.includes(label) || label.startsWith('accessor');
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>'"]/g, (char) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[char]);
  }

  function simpleRowLabel(row) {
    const clone = row.cloneNode(true);
    clone.querySelectorAll('svg, img, small, api-button').forEach((node) => node.remove());
    let label = String(clone.textContent || '').replace(/\s+/g, ' ').trim();
    label = label.replace(/^\d{2}\s+/, '').trim();
    return label;
  }

  function cleanSimpleSubmenus() {
    const drawer = document.getElementById('MenuDrawer');
    if (!drawer || !mobileMQ.matches) return;

    drawer.querySelectorAll('.drawer__submenu').forEach((submenu) => {
      const back = submenu.querySelector(':scope > button[data-close]');
      if (!back || !isSimpleSubmenuLabel(back.textContent)) return;

      submenu.classList.add('hk-mobile-simple-submenu');
      const rows = submenu.querySelectorAll(':scope > .drawer__scrollable > .drawer__menu-group > a.drawer__menu-item, :scope > .drawer__scrollable > .drawer__menu-group > details > summary.drawer__menu-item');
      rows.forEach((row) => {
        if (row.dataset.hkSimpleClean === 'true') return;
        const label = simpleRowLabel(row);
        if (!label) return;
        row.dataset.hkSimpleClean = 'true';
        row.classList.add('hk-mobile-simple-row');
        row.innerHTML = `<span class="hk-mobile-simple-row__label">${escapeHTML(label)}</span><svg class="hk-mobile-simple-row__arrow" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m7 4 6 6-6 6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      });
    });
  }

  function scheduleOffsets() {
    setOffsets();
    requestAnimationFrame(setOffsets);
    window.setTimeout(setOffsets, 80);
    window.setTimeout(setOffsets, 220);
  }

  function headerOffset() {
    const header = document.querySelector('.header-section .header, header.header');
    if (!header) return 64;
    const rect = header.getBoundingClientRect();
    return Math.max(0, Math.round(rect.bottom));
  }

  function cloneDesktopTrustBar() {
    const slot = document.querySelector('[data-hiknight-mobile-trust-slot]');
    if (!slot || slot.dataset.hiknightTrustReady === 'true') return;

    const source = document.querySelector('.hiknight-universal-mega .hiknight-mega-menu__trust');
    if (!source) return;

    const clone = source.cloneNode(true);
    clone.classList.add('hk-mobile-drawer__trust');
    clone.removeAttribute('aria-label');
    slot.replaceChildren(clone);
    slot.dataset.hiknightTrustReady = 'true';
  }

  function setOffsets() {
    const top = `${headerOffset()}px`;
    const drawer = document.getElementById('MenuDrawer');
    if (drawer) drawer.style.setProperty('--hk-mobile-header-offset', top);
    document.querySelectorAll('[data-hiknight-mobile-catalog]').forEach((panel) => {
      panel.style.setProperty('--hk-mobile-catalog-top', top);
    });
  }

  function closeCatalog(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hiknight-mobile-catalog-open');
  }

  function openCatalog(panel) {
    if (!panel || !mobileMQ.matches) return;
    scheduleOffsets();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hiknight-mobile-catalog-open');
    panel.querySelector('[data-hiknight-mobile-catalog-close]')?.focus({ preventScroll: true });
  }

  function setupCatalogTriggers() {
    const drawer = document.getElementById('MenuDrawer');
    const panels = [...document.querySelectorAll('[data-hiknight-mobile-catalog]')];
    if (!drawer || panels.length === 0 || drawer.dataset.hiknightCatalogReady === 'true') return;
    drawer.dataset.hiknightCatalogReady = 'true';

    drawer.addEventListener('click', (event) => {
      if (!mobileMQ.matches) return;
      const trigger = event.target.closest('summary, a.drawer__menu-item');
      if (!trigger || !drawer.contains(trigger)) return;
      const label = normalize(trigger.textContent);
      const panel = panels.find((candidate) => normalize(candidate.dataset.triggerLabel) === label);
      if (!panel) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      openCatalog(panel);
    }, true);

    panels.forEach((panel) => {
      panel.querySelector('[data-hiknight-mobile-catalog-close]')?.addEventListener('click', () => closeCatalog(panel));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      panels.filter((panel) => panel.classList.contains('is-open')).forEach(closeCatalog);
    });

    document.querySelectorAll('.menu-drawer-button').forEach((button) => {
      button.addEventListener('click', () => {
        panels.filter((panel) => panel.classList.contains('is-open')).forEach(closeCatalog);
        scheduleOffsets();
        window.setTimeout(cleanSimpleSubmenus, 0);
        window.setTimeout(cleanSimpleSubmenus, 120);
      });
    });
  }

  function init() {
    cloneDesktopTrustBar();
    scheduleOffsets();
    setupCatalogTriggers();
    cleanSimpleSubmenus();

    const drawer = document.getElementById('MenuDrawer');
    if (drawer && drawer.dataset.hkSimpleObserverReady !== 'true') {
      drawer.dataset.hkSimpleObserverReady = 'true';
      const observer = new MutationObserver(() => {
        cleanSimpleSubmenus();
        scheduleOffsets();
      });
      observer.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('resize', () => {
    scheduleOffsets();
    if (!mobileMQ.matches) {
      document.querySelectorAll('[data-hiknight-mobile-catalog].is-open').forEach(closeCatalog);
    }
  }, { passive: true });

  window.addEventListener('scroll', () => {
    if (!mobileMQ.matches) return;
    const drawer = document.getElementById('MenuDrawer');
    const hasOpenCatalog = document.querySelector('[data-hiknight-mobile-catalog].is-open');
    if ((drawer && (drawer.hasAttribute('active') || drawer.hasAttribute('open'))) || hasOpenCatalog) {
      setOffsets();
    }
  }, { passive: true });

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(init, 0);
  });
})();
